<mat-form-field appearance="outline" *ngIf="view === 'data' || view === 'fill'">
    <mat-label>{{ field?.label }}</mat-label>
    <input matInput
        id=""
        type="text"
        [matDatepicker]="picker"
        [ngModel]="value"
        (ngModelChange)="updateValue($event)"
        [min]="minDate"
        [max]="maxDate"
        [required]="required"
        [readonly]="view === 'data'"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="error">{{error}}</mat-error>
</mat-form-field>

<div class="edit" *ngIf="view === 'edit'">

    <mat-checkbox
        [ngModel]="required"
        (ngModelChange)="updateRequired($event)"
    >Requis</mat-checkbox>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Date minimale</mat-label>
        <input matInput
            id=""
            type="text"
            [matDatepicker]="minpicker"
            [ngModel]="minDate"
            (ngModelChange)="updateMinValue($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="minpicker"></mat-datepicker-toggle>
        <mat-datepicker #minpicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Date maximale</mat-label>
        <input matInput
            id=""
            type="text"
            [matDatepicker]="maxpicker"
            [ngModel]="maxDate"
            (ngModelChange)="updateMaxValue($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="maxpicker"></mat-datepicker-toggle>
        <mat-datepicker #maxpicker></mat-datepicker>
    </mat-form-field>

</div>
